import { z } from "zod";
export const knowledgeFormatSchema = z.enum(["PDF", "CSV", "XLSX"]);
export const parsedSectionSchema = z.object({
    text: z.string(),
    page: z.number().int().positive().optional(),
    sheet: z.string().optional(),
    rowFrom: z.number().int().positive().optional(),
    rowTo: z.number().int().positive().optional(),
});
export const KNOWLEDGE_LIMITS = {
    sources: 50,
    fileBytes: 20_000_000,
    currentBytes: 200_000_000,
    stagingBytes: 200_000_000,
};
export const knowledgeUploadSchema = z
    .object({
    requestId: z.string().uuid(),
    name: z.string().trim().min(1).max(200),
    byteSize: z.number().int().positive().max(KNOWLEDGE_LIMITS.fileBytes),
    sha256: z.string().regex(/^[a-f0-9]{64}$/),
    expectedVersion: z.number().int().nonnegative().optional(),
})
    .strict();
export const knowledgeSourceSchema = z.object({
    usedByAgents: z.number().int().nonnegative().optional(),
    id: z.string().uuid(),
    name: z.string(),
    settingsVersion: z.number().int(),
    current: z
        .object({
        id: z.string().uuid(),
        format: knowledgeFormatSchema,
        byteSize: z.number(),
        createdAt: z.string(),
    })
        .nullable(),
    processing: z
        .object({
        versionId: z.string().uuid(),
        status: z.enum(["UPLOADING", "QUEUED", "PROCESSING", "FAILED"]),
        errorCode: z.string().nullable(),
    })
        .nullable(),
});
export const knowledgePageSchema = z.object({
    items: z.array(knowledgeSourceSchema),
    nextCursor: z.string().nullable(),
    enabled: z.boolean(),
    usage: z.object({
        sources: z.number(),
        currentBytes: z.number(),
        reservedBytes: z.number(),
        stagingBytes: z.number(),
        limits: z.object({
            sources: z.number(),
            fileBytes: z.number(),
            currentBytes: z.number(),
            stagingBytes: z.number(),
        }),
    }),
});
export const knowledgeSnapshotSchema = z
    .object({
    knowledgeVersion: z.number().int().nonnegative(),
    profileId: z.string().nullable(),
    generations: z
        .array(z
        .object({
        sourceId: z.string().uuid(),
        generationId: z.string().uuid(),
    })
        .strict())
        .max(50),
})
    .strict();
export const knowledgeHitSchema = z
    .object({
    chunkId: z.string().uuid(),
    sourceId: z.string().uuid(),
    versionId: z.string().uuid(),
    generationId: z.string().uuid(),
    sourceName: z.string().max(200),
    text: z.string().max(12000),
    location: z.string().max(1000),
    score: z.number().finite(),
})
    .strict();
export const knowledgeContextSchema = z
    .object({
    snapshot: knowledgeSnapshotSchema,
    hits: z.array(knowledgeHitSchema).max(6),
})
    .strict();
export const knowledgeConflictSchema = z
    .object({
    chunkIds: z.array(z.string().uuid()).min(1).max(6),
    explanation: z.string().trim().min(1).max(1000),
})
    .strict();
export const setAgentKnowledgeSchema = z
    .object({
    sourceIds: z
        .array(z.string().uuid())
        .max(50)
        .refine((ids) => new Set(ids).size === ids.length),
    expectedVersion: z.number().int().nonnegative(),
})
    .strict();
export const agentKnowledgeSettingsSchema = z.object({
    sourceIds: z.array(z.string().uuid()),
    version: z.number().int(),
    enabled: z.boolean(),
    readonly: z.boolean(),
    escalationReady: z.boolean(),
    sources: z.array(z.object({
        id: z.string().uuid(),
        name: z.string(),
        indexStatus: z.enum([
            "QUEUED",
            "INDEXING",
            "READY",
            "FAILED",
            "UNAVAILABLE",
        ]),
        usedVersionId: z.string().nullable(),
        pendingVersionId: z.string().nullable(),
        errorCode: z.string().nullable(),
    })),
});
//# sourceMappingURL=knowledge.js.map